import { BitmapLayer } from '@deck.gl/layers';
import { TileLayer } from '@deck.gl/geo-layers';

// import turf from 'turf';
class WMSLayer extends TileLayer {
    onViewportLoad() {
        return null;
    }
    renderSubLayers(props) {
        // console.log(props);Í
        const {
            bbox: { west, south, east, north },
            x,
            y,
            z,
        } = props.tile;

        return [
            new BitmapLayer(props, {
                data: null,
                // image: `https://services.sentinel-hub.com/ogc/wms/d39c5845-c8de-481a-a5a9-ba55f39ce58e?service=WMS&request=GetMap&layers=TRUE-COLOR-S2L2A&styles=&format=image%2Fjpeg&transparent=false&version=1.1.1&maxcc=20&preset=TRUE-COLOR-S2L2A&time=2020-05-01%2F2021-05-25&height=256&width=256&srs=EPSG%3A4326&bbox=${west},${south},${east},${north}`,
                // image: `https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX=${z}&TILEROW=${y}&TILECOL=${x}&tk=f17f2d0ddd4f1e2488d13dca42746bb9`,
                image: props.data,
                bounds: [west, south, east, north],
            }),
        ];
    }
}

WMSLayer.layerName = 'WMSLayer';

export { WMSLayer };
